import { action } from 'easy-peasy';
import { IActionRemoveIcd10Code } from '../types';

const removeIcd10Code: IActionRemoveIcd10Code = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeIcd10Code;
